export const state = {
  token: JSON.parse(sessionStorage.getItem("token")),
};
export const actions = {
  logout({ commit }) {
    // 清除 token
    sessionStorage.removeItem("token");
    // 調用 mutations 中的 setUser 並將 token 設為 null
    commit("setUser", null);
  },
};

export const mutations = {
  setUser(state, payload) {
    sessionStorage.setItem("token", JSON.stringify(payload));
    state.token = payload;
  },
};
export const getters = {
  isAuthenticated: state => !!state.token || (!!sessionStorage.getItem("token") && sessionStorage.getItem("token") !== 'null'),
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
};